import React, { useState, useEffect } from 'react';

const TimePicker = ({ labels, startTime, startMinute, endMinute, endTime, onStartTimeChange, onEndTimeChange}) => {
    const [startHours, setStartHours] = useState(startTime);
    const [startMinutes, setStartMinutes] = useState(Number(startMinute));
    const [endHours, setEndHours] = useState(endTime);
    const [endMinutes, setEndMinutes] = useState(Number(endMinute));
    
    useEffect(() => {
        if(startTime) {
            setStartHours(startTime);
        }
        if(endTime) {
            setEndHours(endTime);
        }
    },[startTime, endTime]);

    const handleStartTimeChange = (e) => {
        const selectedHours = e.target.value;
        setStartHours(selectedHours);
        // 부모 컴포넌트로 선택된 시간을 전달
        onStartTimeChange({
            startLabels: labels,
            startTime: selectedHours,
        });
    };

    const handleEndTimeChange = (e) => {
        const selectedHours = e.target.value;
        setEndHours(selectedHours);
        // 부모 컴포넌트로 선택된 시간을 전달
        onEndTimeChange({
            endLabels: labels,
            endTime: selectedHours,
        });
    };

    return (
       <div className="time-container">
            <div className="hospital-time">{labels}</div>
            <div className="start-time hospital-time-info">
                <select className="select-timepicker" value={startHours} onChange={handleStartTimeChange}>
                    {[...Array(24).keys()].map((hour) => (
                        <option key={hour} value={hour}>
                            {hour}
                        </option>
                    ))}
                </select>
                &nbsp;시
                {/*<select value={startMinutes} onChange={(e) => setStartMinutes(e.target.value)}>
                    {[...Array(60).keys()].map((minute) => (
                        <option key={minute} value={minute}>
                            {minute}
                        </option>
                    ))}
                </select>
                분 */}&nbsp;~&nbsp;
                <select className="select-timepicker" value={endHours} onChange={handleEndTimeChange}>
                    {[...Array(24).keys()].map((hour) => (
                        <option key={hour} value={hour}>
                            {hour}
                        </option>
                    ))}
                </select>
                &nbsp;시
                {/*<select value={endMinutes} onChange={(e) => setEndMinutes(e.target.value)}>
                    {[...Array(60).keys()].map((minute) => (
                        <option key={minute} value={minute}>
                            {minute}
                        </option>
                    ))}
                </select>
                분*/}
            </div>
        </div>
    );
};

export default TimePicker;